import { SIDE_BAR_CLASS } from '#utils/constants';
import { useSize } from 'ahooks';

export default function useLayoutContentWidth() {
  const taggetSider = document.querySelector(SIDE_BAR_CLASS);
  const siderSize = useSize(taggetSider);
  // 监听 <html> 尺寸随窗口 resize 变化，驱动重算（sidebar 宽度固定时 useSize 不触发）
  const viewportSize = useSize(document.documentElement);

  return (
    (viewportSize?.width ?? window.innerWidth) - (siderSize?.width ?? 0) - 1
  );
}
